module.exports = __webpack_public_path__ + "static/media/24.f2582dfb.svg";